(function() {
  // グローバル変数
  let shindanData = null;
  let currentState = null;
  const history = [];
  
  // デフォルト画像URL
  const DEFAULT_IMAGE_URL = 'https://shop.moltensports.jp/cdn/shop/files/infohub-basket-training-visual02.jpg?v=1750728000&width=750';

  // ユーザー表示文言
  const UI_TEXT = {
    LOADING: {
      TEXT: '診断中...',
      DURATION_MS: 3000
    },
    BUTTONS: {
      GO_BACK: '戻る',
      RESTART_DIAGNOSIS: '最初から診断する'
    },
    PRODUCTS: {
      VIEW_LINK: '商品を見る',
      RELATED_COLLECTIONS_TITLE: '関連コレクション',
      VIEW_SUFFIX: 'を見る'
    }
  };

  // HTMLテンプレート
  const HTML_TEMPLATES = {
    // ローディング画面
    loading: () => `
      <div class="shindan_loading">
        <div class="loading_spinner"></div>
        <p class="loading_text">${UI_TEXT.LOADING.TEXT}</p>
      </div>
    `,

    // 質問画面
    question: {
      container: (content) => content,
      
      title: (text) => `<h5 class="question_title">${text}</h5>`,
      
      imageContainer: (images) => `
        <div class="question_image">
          ${images}
        </div>
      `,
      
      image: (src) => `<img src="${src}" width="750" height="auto" loading="lazy">`,
      
      optionsList: (options) => `
        <ul class="select_options">
          ${options}
        </ul>
      `,
      
      option: (text, handle, type) => `
        <li class="select_option" data-next="${handle}" data-type="${type}">
          ${text}
        </li>
      `,
      
      optionNoAction: (text) => `
        <li class="select_option select_option--no-action">
          ${text}
        </li>
      `,
      
      backButton: () => `<button class="shindan_back_button">${UI_TEXT.BUTTONS.GO_BACK}</button>`
    },

    // 結果画面
    result: {
      container: (content) => `
        <div class="shindan_result">
          ${content}
        </div>
      `,
      newtitle:()=>`<h5 class="result_title">あなたに最適なボールはこちら</h5>`,
      title: (text) => `<h5 class="result_title">${text}</h5>`,
      
      comment: (text) => `
        <div class="result_comment">
          <p>${text}</p>
        </div>
      `,
      
      productSection: (products) => `
        <div class="result_product">
          ${products}
        </div>
      `,
      
      productItem: (image, title,comment, url) => `
        <div class="result_product_item">
          ${image ? `<img src="${image}" alt="${title}">` : '<img class="hidden" alt="">'}
          <h4>${title}</h4>
          <div class="result_comment">
            <p>${comment}</p>
          </div>
          <a href="${url}" class="result_product_link">${UI_TEXT.PRODUCTS.VIEW_LINK}</a>
        </div>
      `,
      
      // collectionSection: (collections) => `
      //   <div class="result_collection">
      //     <h6 class="result_collection_title">${UI_TEXT.PRODUCTS.RELATED_COLLECTIONS_TITLE}</h6>
      //     ${collections}
      //   </div>
      // `,
      collectionSection: (collections) => `
        <div class="result_collection">
          ${collections}
        </div>
      `,
      
      collectionLink: (handle, title) => `
        <a href="/collections/${handle}" class="result_collection_link">
          ${title}${UI_TEXT.PRODUCTS.VIEW_SUFFIX}
        </a>
      `,
      
      actions: () => `
        <div class="result_actions">
          <button class="shindan_restart_button" onclick="location.reload()">
            ${UI_TEXT.BUTTONS.RESTART_DIAGNOSIS}
          </button>
        </div>
      `
    },

    // エラー画面
    error: (message) => `
      <div class="shindan_error">
        <p>${message}</p>
        <button onclick="location.reload()">ページをリロード</button>
      </div>
    `
  };

  // 初期化関数
  function init() {
    // 診断データをfetch
    fetchShindanData();
  }

  // 診断データを取得
  function fetchShindanData() {
    // 現在のURLのパスを取得
    const currentPath = window.location.pathname;
    // viewパラメータを追加
    const fetchUrl = currentPath + '?view=json-shindan';
    
    fetch(fetchUrl)
      .then(function(response) {
        if (!response.ok) {
          throw new Error('診断データの取得に失敗しました: HTTP ' + response.status);
        }
        return response.text();
      })
      .then(function(text) {
        // JSONをパースする前に、制御文字をチェック
        try {
          const data = JSON.parse(text);
          shindanData = data;
          
          // データの構造を確認
          if (!shindanData.shindan_question || !shindanData.shindan_result) {
            console.error('診断データの構造が不正です:', shindanData);
            showError('診断データの形式が正しくありません。');
            return;
          }
          
          // イベントリスナーを設定
          setupEventListeners();
        } catch (parseError) {
          console.error('JSONパースエラー:', parseError);
          console.error('エラー位置:', parseError.message);
          // エラー位置を特定するために、テキストの一部を表示
          const errorMatch = parseError.message.match(/position (\d+)/);
          if (errorMatch) {
            const position = parseInt(errorMatch[1]);
            const start = Math.max(0, position - 100);
            const end = Math.min(text.length, position + 100);
            console.error('エラー箇所の前後:', text.substring(start, end));
          }
          showError('診断データの形式が正しくありません。JSONの構文エラーが発生しています。');
        }
      })
      .catch(function(error) {
        console.error('診断データの取得エラー:', error);
        showError('診断データの読み込みに失敗しました。ページをリロードしてください。');
      });
  }

  // イベントリスナーの設定
  function setupEventListeners() {
    // 選択肢のクリックイベントを監視
    document.addEventListener('click', function(e) {
      const selectOption = e.target.closest('.select_option');
      if (selectOption) {
        e.preventDefault();
        const nextHandle = selectOption.dataset.next;
        const nextType = selectOption.dataset.type;
        handleSelection(nextHandle, nextType);
      }

      // 戻るボタンのイベント
      if (e.target.classList.contains('shindan_back_button')) {
        e.preventDefault();
        goBack();
      }
    });
  }

  // 選択肢がクリックされた時の処理
  function handleSelection(handle, type) {
    // 現在の状態を履歴に保存
    const currentContent = document.querySelector('.shindan_contents_inner');
    if (currentContent) {
      history.push({
        html: currentContent.innerHTML,
        state: currentState
      });
    }

    // 次の内容を表示
    if (type === 'shindan_question') {
      showQuestion(handle);
    } else if (type === 'shindan_result') {
      // 結果表示前にローディングを表示
      showLoading();
      // 設定された時間後に結果を表示
      setTimeout(function() {
        showResult(handle);
      }, UI_TEXT.LOADING.DURATION_MS);
    }
  }

  // ローディング画面を表示
  function showLoading() {
    updateContent(HTML_TEMPLATES.loading());
  }

  // 質問を表示
  function showQuestion(handle) {
    // result時だけclass付与
    document.querySelector('.shindan_wrapper')?.classList.remove('is-result');
    let question = null;
    for (let i = 0; i < shindanData.shindan_question.length; i++) {
      if (shindanData.shindan_question[i].handle === handle) {
        question = shindanData.shindan_question[i];
        break;
      }
    }

    if (!question) {
      console.error('質問が見つかりません:', handle);
      console.error('利用可能な質問のhandle一覧:', shindanData.shindan_question.map(q => q.handle));
      return;
    }
    

    currentState = { type: 'question', handle: handle };
    
    // タイトル
    let contentHtml = HTML_TEMPLATES.question.title(escapeHtml(question.title));
    
    // 画像を表示（ない場合はデフォルト画像）(6.10画像表示❌にした)
    // let images = '';
    // if (question.image_list && question.image_list.length > 0) {
    //   for (let i = 0; i < question.image_list.length; i++) {
    //     images += HTML_TEMPLATES.question.image(question.image_list[i]);
    //   }
    // } else {
    //   // デフォルト画像を表示
    //   images = HTML_TEMPLATES.question.image(DEFAULT_IMAGE_URL);
    // }
    // contentHtml += HTML_TEMPLATES.question.imageContainer(images);
    
    // 選択肢
    let options = '';
    const maxLength = Math.max(
      question.question_list ? question.question_list.length : 0,
      question.next_list ? question.next_list.length : 0
    );
    
    for (let i = 0; i < maxLength; i++) {
      const text = question.question_list && question.question_list[i];
      const next = question.next_list && question.next_list[i];
      
      if (text && text !== '') {
        
        if (next) {
          options += HTML_TEMPLATES.question.option(escapeHtml(text), next.handle, next.type);
        } else {
          // テキストはあるが次の遷移先がない場合
          options += HTML_TEMPLATES.question.optionNoAction(escapeHtml(text));
        }
      }
    }
    contentHtml += HTML_TEMPLATES.question.optionsList(options);
    
    // 戻るボタン
    if (history.length > 0) {
      contentHtml += HTML_TEMPLATES.question.backButton();
    }

    updateContent(contentHtml);
  }

  // 結果を表示
  function showResult(handle) {
    let result = null;
    for (let i = 0; i < shindanData.shindan_result.length; i++) {
      if (shindanData.shindan_result[i].handle === handle) {
        result = shindanData.shindan_result[i];
        break;
      }
    }

    if (!result) {
      console.error('結果が見つかりません:', handle);
      return;
    }

    currentState = { type: 'result', handle: handle };
    
    let content = '';

    // タイトル6.10レイアウト改装
    content += HTML_TEMPLATES.result.newtitle(escapeHtml(result.newtitle));
    const commentText = result.comment
    ? result.comment
      .replace(/^あなたにおすすめ(?:な|の)サッカーボールはこちら！/, '')
      .trim()
    : '';
    // おすすめ商品
    if (result.variant && result.variant.length > 0) {
      let products = '';
      for (let i = 0; i < result.variant.length; i++) {
        const v = result.variant[i];
        // 空の値や無効な値をチェック
        if (v && v.title && v.title.trim() !== '' && v.title.trim() !== ' / ' && v.url && v.url.trim() !== '') {
          // variant.titleが"Default Title"の場合は、/ Default Titleの部分を削除
          let displayTitle = v.title.trim();
          if (displayTitle.endsWith(' / Default Title')) {
            displayTitle = displayTitle.replace(/ \/ Default Title$/, '');
          }
          
          // 画像の優先順位: 1. variant image, 2. product image, 3. hidden
          let imageUrl = null;
          if (v.image && v.image.trim() !== '' && v.image.trim() !== 'https://shop.moltensports.jp/cdn/shop/') {
            imageUrl = v.image;
          } else if (v.product_image && v.product_image.trim() !== '') {
            imageUrl = v.product_image;
          }
          
          products += HTML_TEMPLATES.result.productItem(
            imageUrl,
            escapeHtml(displayTitle),
            escapeHtml(commentText),
            v.url
          );
        }
      }
      if (products !== '') {
        content += HTML_TEMPLATES.result.productSection(products);
      }
    }
    // // タイトル
    // content += HTML_TEMPLATES.result.title(escapeHtml(result.title));
    
    // コメントがある場合 6.10場所移動
    // if (result.comment && result.comment !== '') {
    //   const commentText = result.comment
    //     .replace(/^あなたにおすすめ(?:な|の)サッカーボールはこちら！/, '')
    //     .trim();
    //     content += HTML_TEMPLATES.result.comment(
    //     escapeHtml(commentText)
    //   );
    // }
    
    // 関連コレクション
  
    if (result.collection && result.collection.length > 0) {
      let collections = '';

      for (let i = 0; i < result.collection.length; i++) {
        const c = result.collection[i];
        // 空の値や無効な値をチェック
        if (c && c.handle && c.handle.trim() !== '' && c.title && c.title.trim() !== '') {
          const displayTitle = escapeHtml(c.title).replace(
            /ボール(?!.*ボール)/,
            'ボール<span class="sp"><br></span>'
          );
          collections += HTML_TEMPLATES.result.collectionLink(
            c.handle,
            displayTitle
          );
        }
      }
      if (collections !== '') {
        content += HTML_TEMPLATES.result.collectionSection(collections);
      }
    }
    
    // アクションボタン
    content += HTML_TEMPLATES.result.actions();
    
    // 結果コンテナに包む
    const contentHtml = HTML_TEMPLATES.result.container(content);

    updateContent(contentHtml);
    // result時だけclass付与
    document.querySelector('.shindan_wrapper')?.classList.add('is-result');
  }


  // コンテンツを更新
  function updateContent(html) {
    const contentInner = document.querySelector('.shindan_contents_inner');
    if (contentInner) {
      contentInner.innerHTML = html;
    }
  }

  // 前の状態に戻る
  function goBack() {
    document.querySelector('.shindan_wrapper')?.classList.remove('is-result');
    if (history.length > 0) {
      const previousState = history.pop();
      const contentInner = document.querySelector('.shindan_contents_inner');
      if (contentInner && previousState) {
        contentInner.innerHTML = previousState.html;
        currentState = previousState.state;
      }
    }
  }

  // エラーを表示
  function showError(message) {
    const contentInner = document.querySelector('.shindan_contents_inner');
    if (contentInner) {
      contentInner.innerHTML = HTML_TEMPLATES.error(escapeHtml(message));
    }
  }

  // HTMLエスケープ
  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  // DOMContentLoadedで初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      if (document.querySelector('.shindan')) {
        init();
      }
    });
  } else {
    if (document.querySelector('.shindan')) {
      init();
    }
  }
})();
